import { default as videojs }  from 'video.js';
import { PlanetVideoJs } from '../models';
import { CinematicOptions } from '../models/cinematic-options';

const MenuButton: typeof videojs.MenuButton = videojs.getComponent('MenuButton');

export class CinematicViewToggle extends MenuButton {

    static readonly ComponentName: string = 'CinematicViewToggle';

    player_: PlanetVideoJs;

    private cinematic: boolean;

    constructor(player: PlanetVideoJs, options?: CinematicOptions) {
        super(player, options);

        this.cinematic = options?.isCinematic;
        this.check();
        this.el().classList.add('cinematic-view-toggle-container');
    }

    /**
     * @inheritDoc
     */
    name(): string {
        return CinematicViewToggle.ComponentName;
    }

    buildCSSClass(): string {
        return `material-icons cinematic-view-toggle`;
    }

    handleClick(event: videojs.EventTarget.Event): void {
        this.cinematic = !this.cinematic;
        this.check();
    }

    isCinematicView(): boolean {
        return this.cinematic;
    }

    toggle(enabled: boolean): void {
        this.cinematic = enabled;
        this.check();
    }

    private check(): void {
        if (this.cinematic) {
            this.el().children.item(0).innerHTML = 'crop_16_9';
        } else {
            this.el().children.item(0).innerHTML = 'crop_7_5';
        }
    }
}
